import { Field, FieldProps, useControlId } from './Field'

export function DateField({
  label,
  error,
  hint,
  labelStyle = 'static',
  className,
  style,
  id,
  value,
  onChange,
  controlClassName = '',
  ...rest
}: FieldProps & {
  value: string
  onChange: (value: string) => void
  controlClassName?: string
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'id' | 'className' | 'style' | 'type'>) {
  const controlId = useControlId(id)

  return (
    <Field label={label} error={error} hint={hint} labelStyle={labelStyle} className={className} style={style} controlId={controlId}>
      <input
        id={controlId}
        type="date"
        className={`${controlClassName} form-control`.trim()}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        {...rest}
      />
    </Field>
  )
}
